import React from 'react';

import { NavigationHeaderProps } from '@epi-models/components/NavigationHeader';
import history from '../../routes/history';
import { BackButton } from '../BackButton/BackButton';

import './NavigationHeader.scss';
import { Box } from 'edenred-ui';

export const NavigationHeader = ({
  children,
  withBackButton = false,
  onClickBack = () => history.goBack(),
  title,
  className = ''
}: NavigationHeaderProps) => (
  <Box className={`NavigationHeader ${className}`}>
    <Box
      display="flex"
      className={`NavigationHeader-header mb-30 ${
        !withBackButton ? 'with-back-button' : ''
      }`}
    >
      {withBackButton && <BackButton onClick={onClickBack} />}
      <h2 className="title">{title}</h2>
    </Box>
    {children && <div className="NavigationHeader-body">{children}</div>}
  </Box>
);
